import { connectCustom } from "@client/lib/misc";
import SocialIcons, { type SocialProps } from "@client/widgets/SocialIcons/component";
import classnames from "classnames";
import { itemsSelector, sidePanelSocialIconsStyleSelector, sidePanelSocialSelector } from "./selectors";

const mapStateToProps = (state): SocialProps => {
  return {
    className: classnames("text-center", sidePanelSocialIconsStyleSelector(state)),
    items: itemsSelector(state),
    isVisible: !!sidePanelSocialSelector(state)
  };
};

export default connectCustom(mapStateToProps)(SocialIcons);
